import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {RouteService} from '../../../shared/services/route.service';
import {Stop} from '../../../shared/models/stop.model';
import {DataStorageService} from '../../../shared/services/data-storage.service';
import {EditingService} from '../../../shared/services/editing.service';
import {FlightCreate, FlightUpdate} from '../../../shared/models/flight.model';
import {Passenger, PassengerUpdate} from 'src/app/shared/models/passenger.model';
import {Subject} from 'rxjs/Rx';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-edit-passenger',
    templateUrl: 'form-edit-passenger.html'
})
export class FormEditPassengerComponent implements OnInit, OnDestroy {

    @Input() passenger_id: number;
    @Input() passenger: Passenger;
    @Input() reservation_id: number;

    bookingForm: FormGroup;

    isValidTicket: boolean;

    stops: Stop[] = [];

    passengerTypeOptions: any = [{'value': ''}, {'value': 'Adult'}, {'value': 'Child'},{'value': 'Infant'}];

    selectConfig: any = {
        labelField: 'value',
        valueField: 'value',
        searchField: ['value']
    };

    date: string;

    amount = 0;

    pnr: string;

    log_txt = '';
    error_message: string;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private routeService: RouteService,
                private dataStorageService: DataStorageService,
                private editingService: EditingService) {
        this.error_message = '';
    }

    ngOnInit() {

        // console.log(this.passenger);

        if (this.passenger.flight) {
            this.pnr = this.passenger.flight.pnr;
        }

        this.initBookingForm();
        this.setInfantControl();


        this.bookingForm.get('passenger').get('type').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const ticketInfantControl = this.bookingForm.get('passenger');
                    if (value === 'Adult') {
                        this.editingService.plus_adult_num(1);
                        this.editingService.minus_child_num(1);
                        this.editingService.minus_infant_num(1);
                    } else if (value === 'Child') {
                        this.editingService.plus_child_num(1);
                        this.editingService.minus_adult_num(1);
                        this.editingService.minus_infant_num(1);
                    } else if (value === 'Infant') {
                        ticketInfantControl.get('ticket_no').disable();
                        this.editingService.plus_infant_num(1);
                        this.editingService.minus_adult_num(1);
                        this.editingService.minus_child_num(1);
                    }
                    this.editingService.setInvoice();
                }
            );

        this.editingService.isValidTicketChanged.pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.isValidTicket = value;
                this.toggleTicketInformation();
            }
        );

        this.editingService.pnrChanged.pipe(takeUntil(this.unsubscribe$)).subscribe(
            value => {
                this.pnr = value;
            }
        );

        this.editingService.setPassengersEmitter.pipe(takeUntil(this.unsubscribe$)).subscribe(
            () => {
                this.onSubmit();
            }
        );

        this.bookingForm.get('passenger').get('is_divide').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const passenger = new PassengerUpdate(this.passenger.id, this.reservation_id
                        , this.passenger.first_name, this.passenger.last_name, this.passenger.type);
                    if (value === true) {
                        this.editingService.addIsDividePassengers(passenger);
                    } else if (value === false) {
                        this.editingService.removeIsDividePassengers(passenger);
                    }
                }
            );

    }
    setInfantControl(){

    }
    onSubmit() {

        this.setTimeForCheckError();

        console.log(this.bookingForm.value);


        // Passenger
        if (this.passenger.last_name === this.bookingForm.value.passenger.last_name
            && this.passenger.first_name === this.bookingForm.value.passenger.first_name
            && this.passenger.type === this.bookingForm.value.passenger.type) {
            // same
        } else {
            // update
            const newPassenger = new PassengerUpdate(
                this.passenger.id,
                this.reservation_id,
                this.bookingForm.value.passenger.first_name,
                this.bookingForm.value.passenger.last_name,
                this.bookingForm.value.passenger.type
            );

            this.dataStorageService.updatePassenger(newPassenger)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                    responseData => {
                        // have to add updating.
                        if (responseData['error']) {
                            this.error_message += 'Error occurred on passenger ' + this.passenger.last_name
                                + '/' + this.passenger.first_name + ' update. ';
                        } else {
                            // log
                            if (this.passenger.last_name !== this.bookingForm.value.passenger.last_name) {
                                this.log_txt += 'Passenger last name changed from '
                                    + this.passenger.last_name
                                    + ' to ' + this.bookingForm.value.passenger.last_name + '.<br>';
                            }
                            if (this.passenger.first_name !== this.bookingForm.value.passenger.first_name) {
                                this.log_txt += 'Passenger first name changed from '
                                    + this.passenger.first_name
                                    + ' to ' + this.bookingForm.value.passenger.first_name + '.<br>';
                            }
                            if (this.passenger.type !== this.bookingForm.value.passenger.type) {
                                this.log_txt += 'Passenger type changed from '
                                    + this.passenger.type
                                    + ' to ' + this.bookingForm.value.passenger.type + '.<br>';
                            }
                        }
                    }
                );
        }


        // Flight
        if (this.isValidTicket) {
            if (this.passenger.flight) {
                if (this.passenger.flight.ticket_no === this.bookingForm.value.passenger.ticket_no
                    && this.passenger.flight.pnr === this.pnr) {
                    // same
                } else {
                    // update
                    const new_flight =
                        new FlightUpdate(this.passenger.flight.id, this.passenger.id,
                            this.bookingForm.value.passenger.ticket_no, this.pnr);
                    this.dataStorageService.updateFlight(new_flight)
                        .pipe(takeUntil(this.unsubscribe$)).subscribe(
                            responseData => {
                                if (responseData['error']) {
                                    this.error_message += 'Error occurred on passenger ' + this.passenger.last_name
                                        + '/' + this.passenger.first_name + ' flight update. ';
                                } else {
                                    // log
                                    if (this.passenger.flight.ticket_no !== this.bookingForm.value.passenger.ticket_no) {
                                        this.log_txt += 'Passenger Ticket No changed from '
                                            + this.passenger.flight.ticket_no
                                            + ' to ' + this.bookingForm.value.passenger.ticket_no + '.<br>';
                                    }
                                    if (this.passenger.flight.pnr !== this.pnr) {
                                        this.log_txt += 'Passenger PNR changed from '
                                            + this.passenger.flight.pnr
                                            + ' to ' + this.pnr + '.<br>';
                                    }
                                }

                            }
                        );
                }
            } else {
                // create
                const new_flight =
                    new FlightCreate(this.passenger.id,
                        this.bookingForm.value.passenger.ticket_no, this.pnr);
                this.dataStorageService.createFlight(new_flight)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                        responseData => {
                            if (responseData['error']) {
                                this.error_message += 'Error occurred on passenger ' + this.passenger.last_name
                                    + '/' + this.passenger.first_name + ' flight create. ';
                            } else {
                                this.log_txt += 'Passenger PNR ' + this.pnr + 'added. ';
                            }
                        }
                    );
            }
        } else {
            if (this.passenger.flight) {
                // delete
                this.dataStorageService.deleteFlight(this.passenger.flight.id)
                    .pipe(takeUntil(this.unsubscribe$)).subscribe(
                        responseData => {
                            if (responseData['error']) {
                                this.error_message += 'Error occurred on passenger ' + this.passenger.last_name
                                    + '/' + this.passenger.first_name + ' flight delete. ';
                            } else {
                                this.log_txt += 'Passenger flight ' + this.passenger.flight.ticket_no + ' ' + this.passenger.flight.pnr + 'deleted. ';
                            }
                        }
                    );
            }
        }

    }

    initBookingForm() {

        if (this.passenger.flight) {
            this.isValidTicket = true;
        } else {
            this.isValidTicket = false;
        }

        this.bookingForm = new FormGroup({
            'passenger': new FormGroup({
                'first_name': new FormControl(this.passenger.first_name),
                'last_name': new FormControl(this.passenger.last_name),
                'ticket_no': new FormControl(this.isValidTicket ? this.passenger.flight.ticket_no : null),
                'type': new FormControl(this.passenger.type),
                'is_divide': new FormControl()
            })
        });

    }

    toggleTicketInformation() {
        if (this.isValidTicket) {
            this.bookingForm.addControl('ticket_no', new FormControl());
            this.bookingForm.addControl('pnr', new FormControl());
        } else {
            this.bookingForm.removeControl('ticket_no');
            this.bookingForm.removeControl('pnr');
        }
    }

    setTimeForCheckError() {
        setTimeout(() => {
            console.log('passenger done');
            if (this.error_message === '') {
                // give signal to edit-reservation
                this.editingService.log_txt_sub.next(this.log_txt);
            } else {
                // error
                this.editingService.error_message_sub.next(this.error_message);
            }
        }, 1000);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
